import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8750f9fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vmcms" }
const _hoisted_2 = { class: "powerful_code-main" }
const _hoisted_3 = { class: "page-app active page" }
const _hoisted_4 = {
  class: "page-phone",
  style: {"background":"rgb(255, 255, 255)"}
}
const _hoisted_5 = { class: "page-render page" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div data-v-149e9d2f=\"\" data-v-6373e7dc=\"\" class=\"banner-img active\" data-v-8750f9fe><img data-v-149e9d2f=\"\" src=\"https://img-haodanku-com.cdn.fudaiapp.com/FjZCNgjJWUvyR8rFPRst1skQPRSM_600\" alt=\"\" class=\"bg\" data-v-8750f9fe></div><div class=\"rich-text-box-wrapper\" data-v-8750f9fe><div class=\"editor-content-view\" data-v-8750f9fe><p style=\"line-height:2;margin:15px 0;\" data-v-8750f9fe><span style=\"font-size:19px;\" data-v-8750f9fe><strong data-v-8750f9fe>↓直接点</strong></span></p></div></div>", 2)
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.texts, (text, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("button", {
                  class: "coppy_button",
                  onClick: ($event: any) => (_ctx.copyText(text.title+'\n'+text.value)),
                  style: {"background":"linear-gradient(\r\n                    90deg,\r\n                    rgb(251, 136, 77) 0%,\r\n                    rgb(247, 62, 40) 100%\r\n                  )"}
                }, _toDisplayString(text.title), 9, _hoisted_8)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}